import { useMatch } from 'react-router-dom';
import { AppHeader, AppHeaderActions } from '@/components/AppHeader';
import { useAppHeaderState } from '@/components/AppHeader/useAppHeaderState';
import { AuthRightColumn, SlimHeader } from '@/components/SlimHeader';
import { useCurrentUserContext } from '@/contexts';
import { useIsSharePage } from '@/features/magic/hooks/useIsSharePage';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { useIsMobileBreakpoint } from '@/hooks/useIsBreakpoint';
import { useIsMagic } from '@/hooks/useIsMagic';
import type { FlexProps } from '@/ui';
import { Cta } from './Cta';
import { Tabs } from './Tabs';

export const Header = (props: FlexProps) => {
  const { isLoading, isAuthenticated } = useCurrentUserContext();
  const isMobileBreakpoint = useIsMobileBreakpoint();
  const { isSharePage } = useIsSharePage();
  const { isMagic, isMagicLandingPage } = useIsMagic();
  const { isActive } = useAppHeaderState();
  const isLibrary = useMatch('/dashboard') !== null;
  const { value: libraryMagicPromptEnabled } = useFeatureFlag(
    'libraryMagicPromptEnabled'
  );
  const isLibraryMagicPrompt = isLibrary && libraryMagicPromptEnabled;

  if (isActive) {
    return (
      <AppHeader
        actions={<AppHeaderActions />}
        variant={
          isMagic || isMagicLandingPage || isLibraryMagicPrompt
            ? 'magic'
            : 'default'
        }
      />
    );
  }

  const showCta =
    !isLoading && !isAuthenticated && !isMobileBreakpoint && isSharePage;

  const showTabs = !isLoading;

  return (
    // Above the page, as AppHeader is on the magic gradient, so the magic
    // mascot can rise into the nav's padding without covering its links.
    <SlimHeader
      pos="relative"
      zIndex={1}
      {...props}
      logoHref={isAuthenticated ? { to: '/dashboard' } : 'default'}
      middleColumn={showCta ? <Cta /> : showTabs ? <Tabs /> : null}
      rightColumn={<AuthRightColumn buttonProps={{ width: { md: 'auto' } }} />}
    />
  );
};
